export default __webpack_public_path__ + "static/media/manufacturinghazard.a0dda04d.png";